<template>
    <customers-form></customers-form>
</template>

<script>
import CustomersForm from '@/components/Catalogs/CustomersForm';

export default {
    name: 'CustomerForm',
    components: {
        CustomersForm
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                document.title = 'Customer';
            }
        }
    }
};
</script>
